import type {SlotGameStore} from "@gamzix/slot_core";

class UIComponent extends SlotGame.src.component.UIComponent {

    public onInfoClick() {
        super.onInfoClick();

        this.onChangeOrientation();
      }

      public onRulesClick() {
        super.onRulesClick();

        this.getFixWidthPolishTextRules();
        this.getFixWidthJapanTextRules();

        this.onChangeOrientation();
    }

    setMobilePortraitConfigTextWidth(elementName, maxWidth = 1030, positionX = 0) {
        const elementObj = game.tree.findByName(elementName);
        if (elementObj === undefined) {
            throw console.error(`game.tree.findByName: ${elementName} --- undefined`);
        }

        if(positionX) {
            //Set position.x + width
            elementObj.options.layout.mobile_portrait["wordWrap"] = false;
            elementObj.options.layout.mobile_portrait["width"] = maxWidth;
            elementObj.options.layout.mobile_portrait["position"]["x"] = positionX;

        } else {
            //Set width
            elementObj.options.layout.mobile_portrait["wordWrap"] = false;
            elementObj.options.layout.mobile_portrait["width"] = maxWidth;
        }
    }

    getFixWidthJapanTextRules() {
        const isNotJapanLanguage: boolean = (<SlotGameStore>game.store).language !== "ja";
        if (isNotJapanLanguage) return

        this.setMobilePortraitConfigTextWidth("game_rules.table.button_auto_play.descr", 700);
        this.setMobilePortraitConfigTextWidth("game_rules.table.button_switch_bet.descr", 700);
        this.setMobilePortraitConfigTextWidth("game_rules.table.button_icon_menu.descr", 650);
        this.setMobilePortraitConfigTextWidth("game_rules.table.button_settings.descr", 650);
        this.setMobilePortraitConfigTextWidth("game_rules.table.button_paytable.name_value", 150, -300);
        this.setMobilePortraitConfigTextWidth("game_rules.table.button_paytable.descr", 700);
        this.setMobilePortraitConfigTextWidth("game_rules.table.button_rules.descr", 650);
        this.setMobilePortraitConfigTextWidth("game_rules.table.button_close.descr", 700);
        this.setMobilePortraitConfigTextWidth("game_rules.table.button_home.descr", 700);
        this.setMobilePortraitConfigTextWidth("game_rules.table.button_spin.descr", 700);
        this.setMobilePortraitConfigTextWidth("game_rules.table.button_spin.name_value", 200, -265);
        this.setMobilePortraitConfigTextWidth("game_rules.table.button_doubling.descr", 650);
        this.setMobilePortraitConfigTextWidth("game_rules.gamble_feature_descr", 1000);
        this.setMobilePortraitConfigTextWidth("game_rules.gamble_feature_descr_with_dot", 1000);
        this.setMobilePortraitConfigTextWidth("paytable.stacked_symbol_descr", 1000);
        this.setMobilePortraitConfigTextWidth("game_rules.stacked_symbol_descr", 1000);
        this.setMobilePortraitConfigTextWidth("game_rules.main_ruls_descr", 1000);

        this.onChangeOrientation();
    }

    getFixWidthPolishTextRules() {
        const isNotPoloshLanguage: boolean = (<SlotGameStore>game.store).language !== "pl";
        if (isNotPoloshLanguage) return

        this.setMobilePortraitConfigTextWidth("game_rules.table.button_auto_play.name_value", 180, -265);

        this.onChangeOrientation();
    }

    get store(): SlotGameStore {
        return <SlotGameStore>game.store;
    }
}

//@ts-ignore
Game.src.component.UIComponent = UIComponent;
